// Legal content. German is the authoritative version (German operator + DSGVO).
export const OPERATOR = {
  name: "DR-CODING / DR-FILE",
  person: "David Rakoczy",
  street: "Bertolt-Brecht-Straße 20",
  city: "28876 Oyten",
  country: "Deutschland",
  email: "info@tuningfiles.hu",
  phone: "+49 1522 5373841",
};

export const LEGAL = {
  impressum: {
    title: "Impressum",
    updated: "2025",
    sections: [
      { type: "h", text: "Angaben gemäß § 5 DDG" },
      {
        type: "p",
        text: `${OPERATOR.name}\n${OPERATOR.person}\n${OPERATOR.street}\n${OPERATOR.city}\n${OPERATOR.country}`,
      },
      { type: "h", text: "Kontakt" },
      { type: "p", text: `Telefon: ${OPERATOR.phone}\nE-Mail: ${OPERATOR.email}` },
      { type: "h", text: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV" },
      { type: "p", text: `${OPERATOR.person}, Anschrift wie oben.` },
      { type: "h", text: "Wichtiger Hinweis / Haftungsausschluss" },
      {
        type: "p",
        text: "Jegliche Software- oder Datenstandänderung, die auf ein Steuergerät aufgespielt („geflasht“) wird, kann zum Erlöschen der Betriebserlaubnis gemäß § 19 Abs. 2 StVZO führen, sofern keine entsprechende Eintragung, Genehmigung oder Abnahme erfolgt. Durch Softwareänderungen kann der Garantie- und Gewährleistungsanspruch entfallen.",
      },
      {
        type: "p",
        text: "Wir bieten ausschließlich Software- bzw. Datenstandsentwicklung an und keinen Vor-Ort-Service. Die Verantwortung für die rechtmäßige Nutzung, Eintragung, Abnahme sowie Aufklärung des Endkunden liegt ausschließlich beim ausführenden Betrieb bzw. Auftraggeber. Eine Haftung unsererseits wird ausdrücklich ausgeschlossen, soweit gesetzlich zulässig.",
      },
      { type: "h", text: "Haftung für Inhalte" },
      {
        type: "p",
        text: "Als Diensteanbieter sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.",
      },
      { type: "h", text: "Haftung für Links" },
      {
        type: "p",
        text: "Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
      },
      { type: "h", text: "Urheberrecht" },
      {
        type: "p",
        text: "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet.",
      },
      { type: "h", text: "EU-Streitschlichtung" },
      {
        type: "p",
        text: "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/. Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
      },
    ],
  },

  datenschutz: {
    title: "Datenschutzerklärung",
    updated: "2025",
    sections: [
      { type: "h", text: "1. Verantwortlicher" },
      {
        type: "p",
        text: `Verantwortlich für die Datenverarbeitung auf dieser Website:\n${OPERATOR.name}\n${OPERATOR.person}\n${OPERATOR.street}, ${OPERATOR.city}, ${OPERATOR.country}\nE-Mail: ${OPERATOR.email}\nTelefon: ${OPERATOR.phone}`,
      },
      { type: "h", text: "2. Allgemeine Hinweise" },
      {
        type: "p",
        text: "Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir verarbeiten Ihre Daten ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, BDSG). In dieser Datenschutzerklärung informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung auf unserer Website.",
      },
      { type: "h", text: "3. Hosting und Server-Logfiles" },
      {
        type: "p",
        text: "Beim Aufrufen unserer Website werden durch den Hosting-Provider automatisch Informationen in Server-Logfiles erfasst (IP-Adresse, Datum und Uhrzeit des Zugriffs, Browsertyp, Betriebssystem, Referrer-URL). Die Verarbeitung erfolgt zur Gewährleistung eines sicheren und stabilen Betriebs auf Grundlage unseres berechtigten Interesses (Art. 6 Abs. 1 lit. f DSGVO).",
      },
      { type: "h", text: "4. Cookies und Einwilligung" },
      {
        type: "p",
        text: "Wir verwenden technisch notwendige Cookies, die für den Betrieb der Website erforderlich sind (Art. 6 Abs. 1 lit. f DSGVO), sowie – nur nach Ihrer ausdrücklichen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) – Cookies für anonyme Statistik/Analyse. Ihre Einwilligung können Sie jederzeit mit Wirkung für die Zukunft über die „Cookie-Einstellungen“ im Footer widerrufen.",
      },
      { type: "h", text: "5. Webanalyse" },
      {
        type: "p",
        text: "Zur Verbesserung unseres Angebots setzen wir – ausschließlich nach Ihrer Einwilligung – ein Analyse-Tool ein, das die Nutzung der Website in aggregierter, weitgehend anonymisierter Form auswertet. Ohne Ihre Einwilligung findet keine Analyse statt.",
      },
      { type: "h", text: "6. Fahrzeug-Konfigurator (externe Einbindung)" },
      {
        type: "p",
        text: "Auf unserer Website binden wir einen Fahrzeug-Konfigurator eines externen Anbieters per iFrame ein. Beim Laden des Konfigurators werden technisch notwendige Daten (u. a. Ihre IP-Adresse) an den Anbieter übertragen, damit der Inhalt dargestellt werden kann. Rechtsgrundlage ist unser berechtigtes Interesse an der Bereitstellung dieser Funktion (Art. 6 Abs. 1 lit. f DSGVO).",
      },
      { type: "h", text: "7. Schriftarten (Web Fonts)" },
      {
        type: "p",
        text: "Zur einheitlichen Darstellung von Schriftarten nutzen wir Web Fonts. Beim Aufruf einer Seite kann dabei eine Verbindung zum Font-Anbieter aufgebaut werden. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.",
      },
      { type: "h", text: "8. Kontaktaufnahme (E-Mail, Telefon, WhatsApp)" },
      {
        type: "p",
        text: "Wenn Sie uns per E-Mail, Telefon oder WhatsApp kontaktieren, verarbeiten wir die von Ihnen mitgeteilten Daten zur Bearbeitung Ihrer Anfrage (Art. 6 Abs. 1 lit. b bzw. f DSGVO). Bei Nutzung von WhatsApp (Meta Platforms Ireland Ltd.) kann eine Übermittlung von Daten in Drittländer erfolgen; bitte beachten Sie die Datenschutzhinweise von WhatsApp.",
      },
      { type: "h", text: "9. Ihre Rechte" },
      {
        type: "ul",
        items: [
          "Recht auf Auskunft (Art. 15 DSGVO)",
          "Recht auf Berichtigung (Art. 16 DSGVO)",
          "Recht auf Löschung (Art. 17 DSGVO)",
          "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
          "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
          "Widerspruchsrecht (Art. 21 DSGVO) und Widerruf erteilter Einwilligungen",
          "Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde (Art. 77 DSGVO)",
        ],
      },
      { type: "h", text: "10. SSL-/TLS-Verschlüsselung" },
      {
        type: "p",
        text: "Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile Ihres Browsers.",
      },
    ],
  },
};
